import { GlobalConfig } from 'ngx-toastr';

// Available options can be found at https://github.com/scttcper/ngx-toastr.
export const ToastrConfig: GlobalConfig = {
  maxOpened: 0,
  autoDismiss: false,
  newestOnTop: true,
  preventDuplicates: true,
  positionClass: 'toast-top-full-width',
  closeButton: true,
  countDuplicates: false,
  timeOut: 5000,
  extendedTimeOut: 5000,
  progressBar: false,
  enableHtml: true,
  iconClasses: {
    error: 'toast-error',
    info: 'toast-info',
    success: 'toast-success',
    warning: 'toast-warning'
  },
  resetTimeoutOnDuplicate: false,
  disableTimeOut: false,
  progressAnimation: 'decreasing',
  toastClass: 'ngx-toastr',
  messageClass: 'toast-message',
  titleClass: 'toast-title',
  easing: 'ease-in',
  easeTime: 300,
  onActivateTick: false,
  tapToDismiss: true,
  includeTitleDuplicates: false,
  payload: null,
};

